"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptions = new Map();
exports.patternSubscriptions = new Map();
//# sourceMappingURL=subscriptions.js.map